import React from "react";
import {withTranslation, WithTranslation} from "react-i18next";
import { KatIcon, KatLabel, KatPopover, KatStatusindicator, KatToggle } from '@amzn/katal-react';
import { isLoginMode } from "src/config/Config";
import MetricsUtil from "src/utils/MetricsUtil";
import ApplicationState from "src/model/ApplicationState";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import GetUserPreferenceResponse, { UserPreference, UserPreferenceResponse } from "src/model/UserPreference";
import { setUserPreferenceUpdateStart } from "src/actions/UserPreferenceAction";
import RequestStatus from "src/model/RequestStatus";

interface StateProps {
    userPreferenceRes: GetUserPreferenceResponse
}

interface OwnProps {
    readonly metricsUtil?: MetricsUtil;
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    userPreferenceRes: state.userPreferenceRes,
});

interface DispatchProps {
    readonly dispatchSetUserPreference: (userPreference: UserPreference) => void,
}

const mapDispatchToProps = (dispatch: Dispatch) => (
    bindActionCreators({
        dispatchSetUserPreference: setUserPreferenceUpdateStart
    }, dispatch)
);
const connector = connect(mapStateToProps, mapDispatchToProps);

type Props = StateProps & OwnProps & DispatchProps & WithTranslation;

interface State {
}

export class Header extends React.Component<Props, State> {
    private readonly metricsUtil: MetricsUtil;

    constructor(props: Props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);

        if (this.props.metricsUtil) {
            this.metricsUtil = this.props.metricsUtil;
        } else {
            this.metricsUtil = MetricsUtil.getDefaultMetricUtil();
        }
    }

    handleChange(event: KatToggle.ChangeEvent) {
        if (this.metricsUtil) {
            this.metricsUtil.publishCounter("recommendation", event.detail.checked ? "enable" : "disable");
        }
        this.props.dispatchSetUserPreference({recommendationEnabled: event.detail.checked});
    }

    getRecommendationEnabled(): boolean {
        if (this.props.userPreferenceRes.requestStatus === RequestStatus.SUCCESS) {
            let userPreference: UserPreference = this.props.userPreferenceRes.data;
            return userPreference.recommendationEnabled;
        }
        // default enabled
        return true;
    }

    produceUserPreference() {
        const { t } = this.props;
        return (
            <div className="user-preference">
                <KatToggle checked={this.getRecommendationEnabled()} className="recommendation-toggle"
                    textChecked={t('SC_FBA_Calc_label_recommendations') + ' ' + t('SC_FBA_Calc_option_on')}
                    textUnchecked={t('SC_FBA_Calc_label_recommendations') + ' ' + t('SC_FBA_Calc_option_off')}
                    onChange={this.handleChange}>
                </KatToggle>
                <KatPopover triggerType="hover" katAriaBehavior="tooltip" position="top">
                    <KatIcon name="info_outline" size="small" slot="trigger"/>
                    <KatLabel text={t('SC_FBA_Calc_tip_recommendationsSwitch')} className="popover-content"/>
                </KatPopover>
            </div>
        );
    }

    render() {
        const { t } = this.props;
        return (
            <div id="RCHeader" className="revenue-calculator">
                <div>
                    <KatLabel text={t('SC_FBA_Calc_title_revenueCalculator')} className="revenue-calculator-header"/>
                </div>
                <div className="even">
                    <KatLabel text={t('SC_FBA_Calc_desc')} className="revenue-calculator-header-content"/>
                    {isLoginMode() && this.produceUserPreference()}
                </div>
                <div>
                    <KatLabel text={t('SC_FBA_Calc_disclaimer')} />: <KatLabel text={t('SC_FBA_Calc_disclaimBody')} />
                </div>
            </div>
        );
    }
}

export default withTranslation()(connector(Header));
